export default {
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  data: function data() {
    return {
      title: '',
      logo: ''
    };
  },
  created: function created() {
    this.title = process.env.VUE_APP_TITLE;
    this.logo = process.env.VUE_APP_LOGO;
    var link = document.querySelector("link[rel*='icon']");
    link.href = this.logo;
  }
};